import { SubscriptionEventColumns } from './events';

export enum EventStatus {
    PROCESSED = 'PROCESSED',
    QUEUED = 'QUEUED',
    REJECTED = 'REJECTED',
    SUCCESS = 'Success',
    DELIVERED = 'DELIVERED',
    SENT = 'Sent',
    UNKNOWN = 'UNKNOWN',
    OPEN = 'OPEN',
    UNDELIVERED = 'UNDELIVERED',
    BOUNCE = 'BOUNCE',
    ERROR = 'error',
    TIMEOUT = 'Timeout',
    FAILED = 'FAILED',
    CLICKED = 'CLICKED',
    NULL_CHECK_FAILED = 'NULL_CHECK_FAILED',
    READ = 'READ',
    CONVERTED = 'CampaignConverted',
    DROPPED = 'Dropped',
    SPAM = 'SPAMREPORT',
    INVALID_SUB = 'INVALID_SUB',
}

export const DELIVERY_TIME_MINS_COL = 'srt_cmp_delivery_time_mins';
export const DELIVERY_TIME_COL = 'srt_cmp_delivery_time';
export const COUNT_EVENT_STATUS_METRIC = 'srt_event_name_count_of_event_status';
export const DELIVERED_EVENT_STATUS = 'count_of_delivered_events';
export const OPENED_EVENT_STATUS = 'count_of_open_events';
export const UNIQUE_OPENED_EVENT = 'count_distinct_of_open_events';
export const SENT_EVENT_STATUS = 'count_of_sent_events';
export const ALL_EVENT_STATUS = 'count_of_all_events';
export const CLICKED_EVENT_STATUS = 'count_of_clicked_events';
export const UNIQUE_CLICKED_EVENT = 'count_distinct_of_clicked_events';
export const CONVERSION_EVENT_STATUS = 'count_of_conversion_events';
export const CUMULATIVE_SENT_EVENTS = 'cumulative_count_of_sent_events';
export const CUMULATIVE_OPENED_EVENTS = 'cumulative_count_of_open_events';
export const CUMULATIVE_DELIVERED_EVENTS =
    'cumulative_count_of_delivered_events';
export const CUMULATIVE_OPENED_BY_DELIVERED =
    'cumulative_count_open_by_delivered';
export const CUMULATIVE_DELIVERED_BY_SENT =
    'cumulative_count_delivered_by_sent';
export const CUMULATIVE_OPENED_BY_SENT = 'cumulative_count_open_by_sent';

export const COUNT_DISTINCT_OF_TOTAL_UNSUBSCRIBED_USERS = `count_distinct_of_total_unsubscribed_users`;
export const COUNT_DISTINCT_OF_GLOBAL_UNSUBSCRIBED_USERS = `count_distinct_of_global_unsubscribed_users`;
export const COUNT_DISTINCT_OF_SUBSCRIPTION_GROUP_UNSUBSCRIBED_USERS = `count_distinct_of_subscription_group_unsubscribed_users`;
export const COUNT_DISTINCT_OF_NULL_CHECK_FAILED_USERS = `count_distinct_of_null_check_failed_users`;
export const COUNT_DISTINCT_OF_FREQUENCY_CAPPING_EXCLUDED_USERS = `count_distinct_of_frequency_capping_excluded_users`;

export const METRIC_NAME_SUFFIX = 'count_distinct_of_users';

export const DELIVERED_EVENT_STATUSES = [EventStatus.DELIVERED];

export const OPENED_EVENT_STATUSES = [EventStatus.OPEN, EventStatus.READ];

export const SENT_EVENT_STATUSES = [
    EventStatus.PROCESSED,
    EventStatus.UNKNOWN,
    EventStatus.REJECTED,
    EventStatus.QUEUED,
    EventStatus.DELIVERED,
    EventStatus.UNDELIVERED,
    EventStatus.BOUNCE,
    EventStatus.SUCCESS,
];

export enum DashBoardChartName {
    BASE_FUNNEL_CHART_TITLE = 'Funnel',
    DELIVERY_CHART_TITLE = 'Delivery Rate',
    BN_DELIVERY_CHART_TITLE = 'Deliveries',
    BN_DELIVERY_RATE_CHART_TITLE = 'Delivery %',
    BN_BOUNCE_CHART_TITLE = 'Bounces',
    FAILURE_REASON_CHART_TITLE = 'Failure reason breakdown',
    OPEN_RATE_CHART_TITLE = 'Open Rate',
    BN_OPEN_RATE_CHART_TITLE = 'Open %',
    BN_UNIQUE_CLICK_RATE_CHART_TITLE = 'Click %',
    BN_UNIQUE_OPEN_CHART_TITLE = 'Unique Opens',
    BN_TOTAL_OPEN_CHART_TITLE = 'Total Opens',
    CLICK_RATE_CHART_TITLE = 'Click Rate',
    BN_UNIQUE_CLICK_CHART_TITLE = 'Unique Clicks',
    BN_TOTAL_CLICK_CHART_TITLE = 'Total Clicks',
    CONVERSION_RATE_CHART_TITLE = 'Conversion Rate',
    CLICK_TRACK_TABLE = 'Link Click Tracking',
    DEVICE_OPEN_CLICK_CHART_TITLE = 'Device Engagement',
    FILTERED_OPEN_RATE_CHART_TITLE = 'Bot Filtered Open Rate',
    FILTERED_CLICK_RATE_CHART_TITLE = 'Bot Filtered Click Rate',
    FILTERED_BN_TOTAL_OPEN_CHART_TITLE = 'Bot Filtered Total Opens',
    FILTERED_BN_UNIQUE_OPEN_CHART_TITLE = 'Bot Filtered Unique Opens',
    FILTERED_BN_TOTAL_CLICK_CHART_TITLE = 'Bot Filtered Total Clicks',
    FILTERED_BN_UNIQUE_CLICK_CHART_TITLE = 'Bot Filtered Unique Clicks',
    UNSUB_CHART_TITLE = 'Unsubscribe Rate',
    BN_UNSUB_CHART_TITLE = 'Unsubscribed Users',
    BN_SPAM_CHART_TITLE = 'Spam Rate',
    PERFORMANCE_OVER_TIME_CHART_TITLE = 'Performance Over time',
    PERFORMANCE_OVER_TIME_CHART_TITLE_AGGREGATED = 'Performance Over time(Aggregated)',
    OPEN_RATE_OVER_TIME_CHART_TITLE = 'Open Rate Over Time (Aggregated)',
}

export const chartOrder = [
    DashBoardChartName.BASE_FUNNEL_CHART_TITLE,
    DashBoardChartName.DELIVERY_CHART_TITLE,
    DashBoardChartName.BN_DELIVERY_CHART_TITLE,
    DashBoardChartName.BN_DELIVERY_RATE_CHART_TITLE,
    DashBoardChartName.BN_BOUNCE_CHART_TITLE,
    DashBoardChartName.FAILURE_REASON_CHART_TITLE,
    DashBoardChartName.OPEN_RATE_CHART_TITLE,
    DashBoardChartName.BN_OPEN_RATE_CHART_TITLE,
    DashBoardChartName.BN_UNIQUE_OPEN_CHART_TITLE,
    DashBoardChartName.BN_TOTAL_OPEN_CHART_TITLE,
    DashBoardChartName.CLICK_RATE_CHART_TITLE,
    DashBoardChartName.BN_UNIQUE_CLICK_CHART_TITLE,
    DashBoardChartName.BN_UNIQUE_CLICK_RATE_CHART_TITLE,
    DashBoardChartName.BN_TOTAL_CLICK_CHART_TITLE,
    DashBoardChartName.CONVERSION_RATE_CHART_TITLE,
    DashBoardChartName.CLICK_TRACK_TABLE,
    DashBoardChartName.DEVICE_OPEN_CLICK_CHART_TITLE,
    DashBoardChartName.FILTERED_OPEN_RATE_CHART_TITLE,
    DashBoardChartName.FILTERED_CLICK_RATE_CHART_TITLE,
    DashBoardChartName.FILTERED_BN_TOTAL_OPEN_CHART_TITLE,
    DashBoardChartName.FILTERED_BN_UNIQUE_OPEN_CHART_TITLE,
    DashBoardChartName.FILTERED_BN_TOTAL_CLICK_CHART_TITLE,
    DashBoardChartName.FILTERED_BN_UNIQUE_CLICK_CHART_TITLE,
    // DashBoardChartName.UNSUB_CHART_TITLE,
    // DashBoardChartName.BN_UNSUB_CHART_TITLE,
    // DashBoardChartName.BN_SPAM_CHART_TITLE,
    DashBoardChartName.PERFORMANCE_OVER_TIME_CHART_TITLE,
    DashBoardChartName.PERFORMANCE_OVER_TIME_CHART_TITLE_AGGREGATED,
    DashBoardChartName.OPEN_RATE_OVER_TIME_CHART_TITLE,
];

export const UNSUBSCRIBED_USERS_METRIC = 'unsubscribed_users';
export const TOTAL_SUBSCRIBED_USERS_METRIC = 'total_subscribed_users';

export const CLICKED_EVENT_STATUSES = [EventStatus.CLICKED];
export const UNDELIVERED_EVENT_STATUSES = [EventStatus.UNDELIVERED];
export const BOUNCE_EVENT_STATUSES = [EventStatus.BOUNCE];
export const FAILED_EVENT_STATUSES = [EventStatus.FAILED, 'Failed'];
export const UNSUBSCRIBE_EVENT_STATUS =
    SubscriptionEventColumns.USER_ACTION_TAKEN;
export const UNSUBSCRIBE_EVENT_STATUSES = [
    SubscriptionEventColumns.USER_ACTION_TAKEN,
];
export const CONVERSION_EVENT_STATUSES = [EventStatus.CONVERTED];

export const ALL_EVENT_STATUSES = [
    EventStatus.SUCCESS,
    EventStatus.FAILED,
    EventStatus.ERROR,
    EventStatus.TIMEOUT,
];

export const UNDELIVERED_EVENT_STATUS = 'count_of_undelivered_events';
export const BOUNCE_EVENT_STATUS = 'count_of_bounce_events';
export const FAILED_EVENT_STATUS = 'count_of_failed_events';

export enum TabName {
    OVERVIEW = 'Overview',
    DELIVERY = 'Delivery',
    ENGAGEMENT = 'Engagement',
    BOT_FILTERED_ENGAGEMENT = 'Engagement - Bots Filtered (BETA)',
    TIME_SERIES = 'Time series',
}
